'use client';
import { Stock } from '@benzinga/stock-reports-manager';
import { formatRoundFixed } from '@benzinga/utils';
// import { EChart } from '../EChart';
import { MappedPeer, mapPeerInfo } from '../../../../../../src/components/Report';
import ReportSection from '../../../../../../src/components/ReportSection';
import { getColor } from '@benzinga/ticker-ui';
import { FaCheck, FaTimes } from 'react-icons/fa';
import { SectionPaywall } from './SectionPaywall';

const columns = [
  {
    header: 'Value',
    key: 'value',
    type: 'number',
  },
  {
    header: 'Quality',
    key: 'quality',
    type: 'number',
  },
  {
    header: 'Growth',
    key: 'growth',
    type: 'number',
  },
  {
    header: 'Momentum',
    key: 'momentum',
    type: 'number',
  },
  {
    header: 'Short',
    key: 'shortTermTrend',
    type: 'boolean',
  },
  {
    header: 'Medium',
    key: 'mediumTermTrend',
    type: 'boolean',
  },
  {
    header: 'Long',
    key: 'longTermTrend',
    type: 'boolean',
  },
];

const TableHeaders = () => {
  return (
    <>
    <div className="grid grid-cols-10">
      <div className="bg-bzblue-700 text-white py-1 font-bold col-span-3 pl-2 lg:pl-6 text-sm">Top Peers</div>
      {columns.map(header => (
        <div className="bg-bzblue-700 text-white py-1 font-bold capitalize text-sm text-center" key={header.header}>
          {header.header}
        </div>
      ))}
    </div>
  </>
  );
};  

export const PeersSection = ({ data, index, rankings }) => {
  const buildTopPeersSection = (data: Stock) => {
    return {
      peers: (data?.peer_info?.top_peers ?? []).map(peer => mapPeerInfo(peer, rankings)),
      title: 'Peer Ratings',
      type: 'top_peers',
    };
  };

  const section = buildTopPeersSection(data);

  return (
    <ReportSection sectionIndex={index} title={section.title}>
      <div className="bg-white">
        <p className="p-6">
          See how {data.general.company_name} compares to its peers in these key performance metrics from Benzinga
          Rankings.
        </p>
        <div className="w-full overflow-x-auto relative">
          <TableHeaders />
          {section?.peers?.map((peer: MappedPeer, idx: number) => {
            return (
              <div className={`grid grid-cols-10${idx % 2 === 0 ? ' bg-bzblue-300' : ''}`} key={idx}>
                <div className="col-span-3 pl-2 lg:pl-6 pr-4 border-b border-bzblue-300 py-1 text-sm">
                  <div className="flex flex-col items-start justify-center">
                    <span className="text-bzblue-800 font-bold">{peer.symbol}</span>
                    <span className="text-xs text-gray-500">{peer.name}</span>
                  </div>
                </div>
                {columns.map(header => {
                  const cellValue = peer.rankings?.[header.key];
                  const numericScore = header.type === 'number' && typeof cellValue === 'number' ? cellValue : null;
                  return (
                  <div
                    className={`col-span-1 border-b border-bzblue-300 flex items-center justify-center text-center ${numericScore !== null ? getColor(numericScore) : ''}`}
                    key={header.key}
                  >
                    {header.type === 'number' && (
                      <span className={numericScore !== null ? getColor(numericScore) : ''}>
                        {numericScore !== null ? formatRoundFixed(numericScore, 2) : 'N/A'}
                      </span>
                    )}
                    {header.type === 'boolean' && (
                      <span
                        className={`p-1 rounded-md ${cellValue === 'Y' ? 'text-green-500 bg-green-200' : 'text-red-500 bg-red-200'}`}
                      >
                        {cellValue === 'Y' ? <FaCheck /> : <FaTimes />}
                      </span>
                    )}
                  </div>
                  );
                })}
              </div>
            );
          })}
          <div className="text-xs text-gray-500 grid grid-cols-3 gap-2 p-4">
            <div className="bg-bzblue-200 rounded-md p-2">
              <strong>Short:</strong> price trend over the last couple of months
            </div>
            <div className="bg-bzblue-200 rounded-md p-2">
              <strong>Medium:</strong> price trend over the last couple of quarters
            </div>
            <div className="bg-bzblue-200 rounded-md p-2">
              <strong>Long:</strong> price trend over the past year
            </div>
          </div>
          <SectionPaywall section="peers" symbol={data.symbol} />
        </div>
        {/* {section?.peers?.map((peer: MappedPeer, idx: number) => (
          <div className="flex flex-col items-center py-4" key={idx}>
            <div className="w-[300px] h-[200px] mx-6">
              <EChart chartOptions={peer.options} />
            </div>
            <div className="text-bzblue-800 text-center rounded-lg bg-bzblue-200 px-4 py-2">
              <div className="text-lg font-bold">
                {peer.symbol} : {peer.exchange}
              </div>
              <div className="text-sm">{peer.name}</div>
            </div>
          </div>
        ))} */}
      </div>
    </ReportSection>
  );
};
